<template>
  <div>
    <div class="modal fade show custom-modal party-search-page" data-backdrop="static" data-keyboard="false" :class="{'modal-show':docUploadShow}" id="myModalDocUpload">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header mr-3">
            <h4 class="modal-title float-left font-weight-bold ml-4 pl-2">Pre-Inspection Documents Upload</h4>
            <button type="button" class="close" @click="closeModal()">&times;</button>
          </div>
          <div class="modal-body mt-4">
            <div class="row">
              <div class="col-12 tablecolor pt-sm-2 pt-md-2 pt-lg-0">
                <table class="table borderless">
                  <thead class>
                    <tr>
                      <th scope="col">PIN</th>
                      <th scope="col">Client Name</th>
                      <th scope="col">Registration Number</th>
                      <th scope="col">Vehicle Make,Model</th>
                      <th scope="col">Inspection Agency name</th>
                    </tr>
                  </thead>
                  <tbody class="bgc-table-body">
                    <tr>
                      <td>
                        <span class="mobile-label">PIN</span>
                        <span>{{documentsUploadData.pinNumber}}</span>
                      </td>
                      <td>
                        <span class="mobile-label">Client Name</span>
                        <span>{{documentsUploadData.clientName}}</span>
                      </td>
                      <td>
                        <span class="mobile-label">Registration Number</span>
                        <span>{{documentsUploadData.regNo}}</span>
                      </td>
                      <td>
                        <span class="mobile-label">Vehicle Make,Model</span>
                        <span>{{documentsUploadData.make}}{{documentsUploadData.model}}</span>
                      </td>
                      <td>
                        <span class="mobile-label">Inspection Agency name</span>
                        <span>{{documentsUploadData.inspAgencyName}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-lg-4">
                <div class="form-group">
                  <float-label label="Odometer Reading*" :fixed='isFloat(documentsUpload.odometerReading.value)'>
                    <input
                      type="text"
                      class="form-control odometer-upload"
                      placeholder="Odometer Reading*"
                      v-model="documentsUpload.odometerReading.value"
                      v-evolvews="documentsUpload.odometerReading"
                      :class="{ 'bgc-error-field': documentsUpload.odometerReading.errorText!=='' }"
                      v-on:keydown="onlyNumber"
                      maxlength="100"
                    >
                  </float-label>
                  <span class="error-text" v-if="documentsUpload.odometerReading.errorText!==''">{{documentsUpload.odometerReading.errorText}}</span>
                </div>
              </div>
              <div :class="{'col-lg-7' : verifyRoles(['EXTERNAL_AGENCY']), 'col-lg-8' : !verifyRoles(['EXTERNAL_AGENCY'])}">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="form-group">
                      <float-label class="docUpload-date" label="Pre Inspection Date*" :fixed='isFloat(documentsUpload.preInspectionDate.value)'>
                        <datepicker
                          class="pre-inspection-date-modal"
                          placeholder="Pre Inspection Date*"
                          :format="'dd/MM/yyyy'"
                          :typeable="true"
                          :disabledDates="disablePreInspectionDate"
                          v-model="documentsUpload.preInspectionDate.value"
                          v-evolvews="documentsUpload.preInspectionDate"
                          :input-class="isInputError(documentsUpload.preInspectionDate.errorText)"
                          @selected="checkError(documentsUpload.preInspectionDate,false)" 
                          @input="checkError(documentsUpload.preInspectionDate,false)" 
                        ></datepicker>
                      </float-label>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6" >
                    <div class="form-group">
                      <div class="float-left time-div">
                        <float-label label="Pre Inspection Time">
                        <vue-timepicker 
                          v-model="documentsUpload.preInspectionTime.value"
                          format="hh:mm A"
                        ></vue-timepicker>
                        </float-label>
                      </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-lg-8">
                <div class="form-group">
                  <float-label label="Pre-Existing Damage*" :fixed='isFloat(documentsUpload.preExistingDamage.value)'>
                    <input type="text" class="form-control preExisting"
                     :class="{ 'bgc-error-field': documentsUpload.preExistingDamage.errorText!=='' }"
                     v-evolvews="documentsUpload.preExistingDamage" placeholder="Pre-Existing Damage*" v-model="documentsUpload.preExistingDamage.value" maxlength="2500">
                  </float-label>
                  <span class="error-text" v-if="documentsUpload.preExistingDamage.errorText!==''">{{documentsUpload.preExistingDamage.errorText}}</span>
                </div>
              </div>
            </div>
            <div class="modal-footer docUpload-modal mt-4 mb-3">
              <div class="row mt-4">
                <div class="col-md-4 col-sm-12 px-0 save-text">{{savePinText}}</div>
                <div class="col-md-8 col-sm-12 px-0">
                  <button
                    type="button"
                    class="bgc-btn-primary d-sm-none d-block col search_button"
                    data-dismiss="modal"
                    @click="goToUploadDocument()"
                    :disabled="disableUpdate"
                  >Upload Documents</button>
                  <button
                    type="button"
                    class="bgc-btn-primary d-sm-block d-none float-right search_button"
                    data-dismiss="modal"
                    @click="goToUploadDocument()"
                    :disabled="disableUpdate"
                  >Upload Documents</button>
                  <button type="button" class="bgc-btn-secondary d-sm-none d-block col save_button mt-3" :disabled="checkSaveBtnStatus()" @click="savePinProposal()">Save</button>
                  <button type="button" class="bgc-btn-secondary d-sm-block d-none float-right save_button" :disabled="checkSaveBtnStatus()" @click="savePinProposal()">Save</button>
                  <button type="button" class="bgc-btn-secondary d-sm-none d-block col back_button mt-3" @click="closeModal()">Back</button>
                  <button type="button" class="bgc-btn-secondary d-sm-block d-none float-right back_button" @click="closeModal()">Back</button>
                  <span v-if="savePinLoading" class="loader float-right"><img src="@/assets/images/loader.gif" alt=""></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import FloatLabel from "@/../../shared_component/FloatLabel.vue";
import VueTimepicker from 'vuejs-timepicker'  
import moment from "moment";
import functions from '@/../../masters/functions.js';
import { reactive, computed } from '@vue/composition-api';


export default {
  name: "DocUploadModal",
  components: {
    Datepicker,
    VueTimepicker,
    FloatLabel
  },
  props: ['documentsUpload','documentsUploadData', 'docUploadShow','disableUpdate', 'savePinLoading', 'savePinText', 'verifyRoles',"documentUploadFlag"],
  setup(props, context){
    let state = reactive({
      time:{
         hh : null, mm : null, A :null
      }
    });
    const isFloat = functions.isFloat;
    const referenceID = functions.referenceID;
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const removeErrorIfNotBlank = functions.removeErrorIfNotBlank;
    const onlyNumber = functions.onlyNumber;
    const disablePreInspectionDate = computed(()=>{
      return {
          from: moment(new Date()).add(1, 'day').startOf('day').toDate()
        }
    })
    function savePinProposal(){
      let date1 = new Date(props.documentsUpload.preInspectionDate.value);
      let date2 = new Date();
      let currTime = moment(new Date()).format("HH:mm");
      if(date1.getFullYear() == date2.getFullYear() && date1.getMonth() == date2.getMonth() && date1.getDate() == date2.getDate()){
        let timeVal = `${props.documentsUpload.preInspectionTime.value.hh}:${props.documentsUpload.preInspectionTime.value.mm} ${props.documentsUpload.preInspectionTime.value.A}`;
        let extractedTime = convertTimeDoc(timeVal);
        let [hours1, mins1] = extractedTime.split(':');
        let [hours2, mins2] = currTime.split(':');
        if(hours1 > hours2){
          context.parent.callSavePin(undefined, true);
          return;
        }else if(hours1 == hours2){
          if(mins1 > mins2){
            context.parent.callSavePin(undefined, true);
            return;
          }
        }
      }
      context.parent.callSavePin(true);
    }
    function convertTimeDoc(timeVal){
      const [time, modifier] = timeVal.split(' ');
      let [hours, minutes] = time.split(':');
      if(hours === '12')
        hours = '00';
      if(modifier === 'PM')
        hours = parseInt(hours, 10) + 12;
      return `${hours}:${minutes}`;
    }
    function checkSaveBtnStatus(){
      if(props.documentsUpload.preInspectionDate.value != null && props.documentsUpload.odometerReading.value && props.documentsUpload.preExistingDamage.value 
      && props.documentsUpload.preInspectionTime.value.A && props.documentsUpload.preInspectionTime.value.hh && props.documentsUpload.preInspectionTime.value.mm){
        return false;
      }
      return true;
    }
    function closeModal(){
      context.emit('close');
    }
    function goToUploadDocument(){
      context.parent.browseUploadPin();
    }
    return {
      isFloat,
      referenceID,
      checkError,
      isInputError,
      removeErrorIfNotBlank,
      onlyNumber,
      checkSaveBtnStatus,
      closeModal,
      disablePreInspectionDate,
      savePinProposal,
      goToUploadDocument
    }
  },
  directives: {
    evolvews: functions.evolvews
  }
};
</script>
<style>
.time-picker .clear-btn{
  top: 6px;
  font-size: 2.0em;
}
.vue__time-picker input.display-time{
  opacity: 1;
  cursor: default;
}
</style>

<style scoped>
.modal-show{
  display:block;
  transform:scaleY(0) scaleX(0);
  animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
#myModalDocUpload{
  display: block;
}
.docUpload-modal{
  display: block;
}
.modal-body {
  overflow-y: hidden;
}
.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  color: #666666;
  font-size: 18px;
  margin-top: 10px;
}
.time-div{
  width:11em;
}
.pm-div{
  width:4em;
}
.save-text{
  font-weight: bold;
}
label {
  display: block;
  height: 15px;
}
.pm-div input[type="radio"] {
    display:none;   
}
.pm-div input[type="radio"]:checked + label {
    color: #1d8cdb;
}
.modal {
  width: 100%;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 1000px;
    margin: 1.75rem auto;
  }
}
input[type="text"],
[type="email"],
[type="date"],
[type="number"],
select.form-control {
  line-height: 33px;
  max-width: 100%;
}
.vfl-has-label {
  position: relative;
  width: 100%;
}
.borderless th {
  border: none;
  padding-bottom: 0px;
}
.borderless td {
  padding-top: 0px;
  padding-bottom: 0px;
}
.tablecolor {
  background-color: rgba(30, 30, 30, 0.05);
}
.bgc-btn-secondary {
  margin-right: 15px;
}
.table thead th {
  vertical-align: top;
}
.mobile-label {
  display: none;
}
@media (max-width: 750px) {
  .table th,
  .table td {
    width: 50%;
    display: inline-block;
  }
  .mobile-label {
    font-size: 14px;
    width: 100%;
    display: block;
    color: #666666;
    font-weight: bold;
  }
  .table thead {
    display: none;
  }
}
@media (max-width: 380px) {
  .bgc-btn-primary {
    width: 100%;
  }
}
.vdp-datepicker__calendar {
  width: auto;
  position: fixed;
}
</style>
